import { useUserSessionContext } from "../contexts/UserSessionContext";

export const useUserGroups = () => {
  const session = useUserSessionContext();
  const groups = session.userSession?.groups || [];

  return {
    askGpc: groups.includes(process.env.REACT_APP_ASK_GPC_GROUP as string),
  };
};
